<template>
  <div class="privacyGame">
      <!-- style="color: red;" -->     
         <p><b>个人信息权限清单</b>

</p><p>    <b>为保障产品正常运行，我们会在以下情形中申请或使用相应的个人信息权限，您可以根据产品名称在本清单中查找并阅读对应产品的个人信息权限清单，并根据您的设备所使用的操作系统进行查阅具体的个人信息权限内容。我们会在调用相关权限时展示其目的，并获取您的授权同意，您也可以根据实际需要对相关权限进行管理。
</b></p><p>
</p><p>
</p><p> 游戏：《魔幻轮回》
</p><p> 1、存储权限（安卓系统、ios系统）
</p><p> 业务场景：游戏功能、发布与互动
</p><p> 信息种类：文件、图片、媒体内容
</p><p> 使用目的：保存游戏数据和实现资源下载
</p><p> </p>
  </div>
</template>
<script>

export default {  
};
</script>